module.exports = __webpack_public_path__ + "static/media/iim-amritsar-logo.e54f5484.png";